import styled from 'styled-components';

const TabContainer = styled.div`
  width: 100%;
`;

const TabList = styled.div`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0 0 2rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Tab = styled.div`
  padding: 0.75rem 1.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
  color: ${props => props.active ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.7)'};
  border-bottom: 2px solid ${props => props.active ? 'rgba(99, 102, 241, 0.8)' : 'transparent'};
  transition: all 0.3s ease;
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`;

const TabPanel = styled.div`
  animation: fadeIn 0.3s ease-out;
  display: ${props => props.active ? 'block' : 'none'};
`;

export { TabContainer, TabList, Tab, TabPanel }; 